export default __webpack_public_path__ + "static/media/rewards.42a8a45e.png";